import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./presentation/screens/home/home.routes').then((routes) => routes.routes),
  },
  {
    path: 'language',
    loadChildren: () =>
      import('./presentation/screens/language/language.routes').then((routes) => routes.routes),
  },
  {
    path: 'resources/:type/:id',
    loadChildren: () =>
      import('./presentation/screens/resource-detail/resource-detail.routes').then(
        (routes) => routes.routes,
      ),
  },
  {
    path: 'resources',
    loadChildren: () =>
      import('./presentation/screens/resources/resources.routes').then((routes) => routes.routes),
  },
  { path: '**', redirectTo: '' },
];
